<template>
    <section class="card">
        <section class="color-area" :style="styleColor"/>
        <section class="card-area">
            <section class="header">
                <div class="lead-name active-limit" :title="customerName">
                    <a :href="customerUrl" :target="'customer' + id" @click="() => sendGtmEvent(gtm.showDeal)">
                        {{ customerName }}
                    </a>
                    <div v-if="multiSelect" class="title-right">
                        <div>
                            <span class="code-number">
                                {{ id }}
                            </span>
                        </div>
                        <div class="card-checkbox">
                            <ui-checkbox 
                                :checked="isChecked" 
                                @update:checked="val => { isChecked = val; handleSelection() }"
                            />
                        </div>
                    </div>
                    <span v-else class="code-number">
                        {{ id }}
                    </span>
                    
                </div>

                <div class="deal">
                    <div v-if="!!productName" class="enterprise-name active-limit" :title="productName">
                        <a :href="productUrl" :target="'product' + id" @click="() => sendGtmEvent(gtm.showProduct)">{{ productName }}</a>
                    </div>
                </div>

                <div class="status">
                    <strong>Status: </strong><span>{{ status }}</span>
                </div>
                <div v-show="!!negociationDisplay.value" class="proposal">
                    <strong>{{ negociationDisplay.description }} </strong><span>{{ negociationDisplay.value | currencyBRL }}</span>
                </div>
            </section>
            <section v-if="isDisplayContactDetails" class="deal-info-lead">
                <div
                    v-if="customerMobile && customerMobile.length > 0"
                    class="number-phone"
                >
                    <uiWhatsapp width="15" height="15" fill="#2e9059"/>
                    <a
                        :href="`https://api.whatsapp.com/send/?phone=55${customerMobile}&text=Olá ${customerName}, tudo bem?`"
                        target="_blank"
                    >
                        {{formatPhoneNew( customerCountryCodeMobile ,customerMobile) }}
                    </a>
                </div>
                
                <div
                    v-else-if="customerPhone && customerPhone.length > 0"
                    class="number-phone"
                >
                    <i class="fa-light fa-phone"/>
                    {{ formatPhoneNew(customerCountryCodePhone ,customerPhone) }}
                </div>
               
                <div
                    v-if="customerEmail.length > 0"
                    class="email"
                >
                    <uiEmail width="15" height="15" fill="#D09B38"/>
                    <a
                        :href="`mailto:${customerEmail}`"
                        target="_blank"
                    >
                        {{ customerEmail }}
                    </a>
                </div>

                <div v-if="customerCpf.length > 0" class="credential">
                    <ui-credential />
                    {{ formatCPF(customerCpf) }}
                </div>

            </section>

            <section class="deal-owner">
                <div class="owner-name active-limit" :title="ownerName">
                    <strong>Responsável: </strong>{{ ownerName }}
                </div>
            </section>

            <section class="footer">
                <div class="idles">
                    <ui-popover-v2 trigger="hover" padding-content="10px">
                        <template #target>
                            <span class="alarm">
                                <em class="far fa-alarm-exclamation content-icon" :style="{'color': idleColor}"	/>
                                <span>{{ idles }}</span></span>
                        </template>
                        <template #content>
                            <div class="message">Tempo nesta etapa/status
                                <button class="message-icon" @click="link()">
                                    <em class="fal fa-info-circle message-icon" />
                                </button>
                            </div>
                            <div class="message">(Ociosidade)</div>
                        </template>
                    </ui-popover-v2>
                    <ui-popover-v2 trigger="hover" padding-content="10px">
                        <template #target>
                            <span class="alarm">
                                <em class="far fa-sync-alt content-icon" /> <span>{{ update }}</span>
                            </span>
                        </template>
                        <template #content>
                            <div class="message">Última atualização:</div>
                            <div class="message">{{ messageUpdate }}</div>
                        </template>
                    </ui-popover-v2>
                </div>

                <div class="options">
                    <span v-if="!!reserve" class="reserve-text">
                        {{ reserve }}
                    </span>
                    <ui-menu-card icon="far fa-ellipsis-v">
                        <template v-if="showButtonsGroup" #topControl >
                            <div class="buttons-group">
                                <button
                                    v-for="typeCard in menuCard"
                                    :key="typeCard.id"
                                    :class="{ active: menuCardActive == typeCard.id }"
                                    :disabled="typeCard.itens.length == 0"
                                    @click="toggleCardMenu(typeCard.id)"
                                >
                                    {{ typeCard.title }}
                                </button>
                            </div>
                        </template>

                        <div class="select" :style="buttonsSize" >
                            <button
                                v-for="item in filteredMenuListActive"
                                :key="item.id"
                                type="button"
                                @click="menuHandler(item.action, card, item.payload, item)"
                            >
                                {{ item.title }}
                            </button>
                        </div>
                    </ui-menu-card>
                </div>
            </section>
        </section>
    </section>
</template>

<script>
	import { uiMenuCard, uiPopoverV2 } from '@/components/ui'
	import { currencyBRL } from '@/filters'

	import helpers from '@/mixins/helpers'
	import { defaultGtm } from './default'
	import { maskIntl } from '@/mixins'
    import { uiCheckbox } from "@/components/ui/form"


	export default {
		name:	"ui-components-kambam-cards-deals",
		components: {
			uiMenuCard,
			uiPopoverV2,
            uiCheckbox
		},

        filters: {
			currencyBRL,
		},

		mixins: [helpers, maskIntl],

		props: {
			card: {
				type: Object,
				required: true,
			},

			id: {
				type: [String, Number],
				required: true,
			},

			status: {
				type: String,
				default: 'Aguardando',
			},

			customerName: {
				type: String,
				default: '',
			},

			ownerImage: {
				type: String,
				default: '',
			},

			ownerName: {
				type: String,
				default: '',
			},

			productName: {
				type: String,
				default: '',
			},

			idles: {
				type: String,
				default: '',
			},

			update: {
				type: String,
				default: '',
			},

			messageUpdate: {
				type: String,
				default: 'teste',
			},

			idleColor: {
				type: String,
				default: '#FFF',
			},

			reserve: {
				type: String,
				default: '',
			},

			cost: {
				type: String,
				default: '',
			},

			proposalValue: {
				type: String,
				default: '',
			},

			menuCard: {
				type: Array,
				default: () => [],
			},
			statusId: {
				type: [String, Number, Boolean],
				default: null
			},
			isPermissionToDuplicateDeal: {
				type: Boolean,
				default: false,
				required: true
			},
            isDisplayContactDetails: {
                type: Boolean,
                default: false,
            },
            customerMobile: {
				type: String,
				default: '',
                required: false
			},

            customerCountryCodeMobile: {
                type: String,
                default: '',
                required: false
            },

            customerPhone: {
				type: String,
				default: '',
                required: false
			},

            customerCountryCodePhone: {
                type: String,
                default: '',
                required: false
            },

			customerEmail: {
				type: String,
				default: '',
                required: false
			},

			customerCpf: {
				type: String,
				default: '',
                required: false
			},

            multiSelect: {
                type: Boolean,
                default: false,
                required: true
            }
		},

		data() {
			return {
				menuCardActive: 1,
				gtm: { ...defaultGtm() },
				switchValue: true,
                isChecked: false,
			}
		},

		computed: {
			styleColor() {
				return {
					background: this.idleColor,
				}
			},

			menuListActive() {
				return this.menuCard.find((item) => item.id == this.menuCardActive).itens
			},

			customerUrl() {
				return this.oldPanelLink('vendas/negocios/' + this.id)
			},

			productUrl() {
				return this.oldPanelLink('empreendimentos/' + this.card.product_id + '/visualizar')
			},

			showButtonsGroup() {
				let show = true
				this.menuCard.forEach((element) => {
					if (element.itens.length == 0) {
						show = false
					}
				})

				return show
			},

			buttonsSize() {
				const size = this.filteredMenuListActive.length
				return `height:${size * 30}px`
			},

			filteredMenuListActive() {
				return this.menuListActive.filter(item => {
					if (item.title === 'Transferência de Reserva' && (!this.card || this.card.reserves === 0)) {
						return false
					}

					if (item.title === 'Duplicar Cliente') {
						return this.isPermissionToDuplicateDeal
					}

					return true
				})
			},

			negociationDisplay() {
				return this.getNegociationValue()
			}
		},

        mounted() {
          this.$root.$on('clear-card-selection', () => {
            this.isChecked = false
          })
        },

        beforeDestroy() {
            this.$root.$off('clear-card-selection')
        },

		methods: {
			menuHandler(action, card, payload, item) {
				if (action == 'transfer.reservations') this.$router.push({name: 'transfer.reservations', query: { negocio: card.id }})

				if (!payload) {
					if(action == 'modal-open-global--request-reserve') this.$root.$emit(action, card, true, false, this.statusId)
					else this.$root.$emit(action, card, this.statusId)
				}
				else this.$root.$emit(action, payload)

				if(item.gtm) this.$gtm.trackEvent(item.gtm)
			},

			link() {
				window.open("https://intercom.help/appfacilita/pt-BR/articles/6598262-como-configurar-editar-e-excluir-regras-de-ociosidade-do-funil-de-vendas-do-facilita", '_blank')
			},

			toggleCardMenu(id) {
				this.menuCardActive = id
			},

			sendGtmEvent(gtm){
				if(gtm) this.$gtm.trackEvent(gtm)
			},

			/**
			 * Essa função é usada para verificar se tem proposta e
			 * exibir proposta caso contrario exibir valor
			 */
			getNegociationValue() {
				if (this.proposalValue && this.proposalValue !== '0.00') {
					return { description: "Proposta:", value: this.proposalValue };
				}

				if (this.cost && this.cost !== '0.00') {
					return { description: "Valor:", value: this.cost };
				}

				return { description: undefined, value: undefined };
			},
            formatCPF(cpf) {
				// Remover todos os caracteres que não são dígitos
				const cleaned = cpf.replace(/\D/g, '');

				// Verificar se o CPF tem o tamanho adequado
				if (cleaned.length === 11) {
					// Formatar como "XXX.XXX.XXX-XX"
					return `${cleaned.slice(0, 3)}.${cleaned.slice(3, 6)}.${cleaned.slice(6, 9)}-${cleaned.slice(9)}`;

				} else {
					// Retornar o CPF original se não for possível formatar
					return cpf;
				}
			},
            handleSelection() {
                if (this.isChecked) {
                  this.$emit('select', this.card)
                } else {
                  this.$emit('deselect', this.card)
                }
            },

		}
	}
</script>
<style lang="stylus" scoped>
	@import './styles.styl';
</style>
